<template>
  <div class="row mx-0 mob">
    <delete-modal confirmBtnText="Այո" declineBtnText="Ոչ"/>
    <div class="col-4 p-0 mob_block">
      <div class="card">
        <div class="card-body">
          <lot-list
            @deleteLot="openDeleteModal"
            @addLots="addLots"
            @deleteLots="deleteLots"
            :lots="rows"
            :isFromOutside="rows[0] ? Boolean(rows[0].is_from_outside) : false"
            :insert-lot-from-outside="false"
            :selected-lot="selectedCpv"
          />
        </div>
      </div>
    </div>
    <div class="col-8 mob_block">
      <transition name="component-fade" mode="out-in">
        <keep-alive>
          <tender-form
            class="bg-white"
            :rows="rows"
          />
        </keep-alive>
      </transition>
    </div>
    <add-cpv-modal />
  </div>
</template>

<script>
  import LotList from '@/components/dashboard/lot/tenders/LotList'
  import TenderForm from './partials/TenderForm'
  import AddCpvModal from './modals/AddCpvModal'
  
  export default {
    name: 'CreateTenderContainer',
    components: {
      LotList,
      TenderForm,
      AddCpvModal,
      DeleteModal: () => import('@/components/helpers/DeleteModal')
    },
    computed: { },
    watch: { },
    data() {
      return {
        selectedCpv: {},
        rows: [],
      }
    },
    mounted() {},
    methods: {
      consoleLog(e){
        console.log(e)
      },
      addLots(lots){
        const lotsData = [...lots]
        lotsData.forEach((lot) => {
          const currentLotDuplicates = this.rows.filter(row => row.code.search( lot.code) !== -1)
          const currentLotDrop = currentLotDuplicates.length + 1
          lot.code = `${lot.code}/${currentLotDrop}` 
        })
        this.rows = [...this.rows, ...lots];
      },
      deleteLots(lots){
        lots.forEach((lot) => {
          const index = this.rows.indexOf(lot);
          if (index > -1) {
            this.rows.splice(index, 1);
          }
        })
      },
      openDeleteModal({ lotId, nextLotIndex }) {
        this.$modal.show('delete-modal', {
          msg: 'Հեռացնե՞լ գնման առարկան',
          callback: async () => {
            this.rows.splice(nextLotIndex-1, 1);
            this.$modal.hide('delete-modal')
          }
        })
      },
    },
  }
</script>

<style scoped>
  .scroll-bar-slim {
    background: rgba(162, 177, 208, 0.13);
    width: 7px;
    position: absolute;
    top: 15px;
    opacity: 1;
    display: block;
    border-radius: 7px;
    z-index: 99;
    right: 1px;
    height: 90.9091px;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  @media only screen and (max-width: 700px) {
      .mob{
          display: flex;
          flex-direction: column;
      }
      .mob_block{
        padding: 0;
        max-width: 100%;
      }
  }
</style>
